import * as Yup from 'yup'

import i18n from '../../../i18n'
import {
  EntityProfileHeaderInfoItemText,
  getEntityProfileHeaderInfoItemInitialValues,
} from '../../Entity'
import { FormikField } from '../../Formik'
import { TextareaOutlineField } from '../../Textarea'

import { InfoItemsFields } from './ProfileHeader.constants'

function EditInfoItemField(props) {
  return (
    <FormikField
      {...props}
      withoutManualResize
      Component={TextareaOutlineField}
      label='Category'
      maxLength={255}
      minRows={4}
      name='category'
    />
  )
}

export function EditTitleField(props) {
  return (
    <FormikField
      {...props}
      required
      withoutManualResize
      Component={TextareaOutlineField}
      label='Title'
      maxLength={255}
      minRows={4}
      name='title'
    />
  )
}

export function getValidationSchemaTitle() {
  return Yup.object({
    title: Yup.string().required(i18n.t('Error.RequiredFieldsErrorKey')),
  })
}

export function renderInfoItem({ name, title, value, ...restProps }) {
  switch (name) {
    case InfoItemsFields.Category: {
      return (
        <EntityProfileHeaderInfoItemText
          {...restProps}
          editModalProps={{
            Fields: EditInfoItemField,
            formTitle: 'Edit category',
            initialValues: getEntityProfileHeaderInfoItemInitialValues({
              name,
              value,
            }),
          }}
          name={name}
          title={title}
          value={value}
        />
      )
    }

    case InfoItemsFields.Category3: {
      return (
        <EntityProfileHeaderInfoItemText
          {...restProps}
          editModalProps={{
            Fields: EditInfoItemField,
            formTitle: 'Edit category 3',
            initialValues: getEntityProfileHeaderInfoItemInitialValues({
              name,
              value,
            }),
          }}
          name={name}
          title={title}
          value={value}
        />
      )
    }

    case InfoItemsFields.DocumentTitle: {
      return (
        <EntityProfileHeaderInfoItemText
          {...restProps}
          editModalProps={{
            Fields: EditInfoItemField,
            formTitle: 'Edit document title',
            initialValues: getEntityProfileHeaderInfoItemInitialValues({
              name,
              value,
            }),
          }}
          name={name}
          title={title}
          value={value}
        />
      )
    }

    case InfoItemsFields.Category2: {
      return (
        <EntityProfileHeaderInfoItemText
          {...restProps}
          editModalProps={{
            Fields: EditInfoItemField,
            formTitle: 'Edit category 2',
            initialValues: getEntityProfileHeaderInfoItemInitialValues({
              name,
              value,
            }),
          }}
          name={name}
          title={title}
          value={value}
        />
      )
    }

    default:
      break
  }
}
